var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleGLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Google__G__Logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.542,
    height: 19.966,
    viewBox: "0 0 19.542 19.966",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M-5.2,51.127a11.566,11.566,0,0,0-.158-1.888h-9.4v3.752h5.383a4.635,4.635,0,0,1-2,2.978v2.5h3.211A9.761,9.761,0,0,0-5.2,51.127Z",
    transform: "translate(24.737 -40.92)",
    fill: "#4285f4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M-16.554,61.607a9.51,9.51,0,0,0,6.6-2.421l-3.211-2.5a6.022,6.022,0,0,1-3.386.965,5.962,5.962,0,0,1-5.6-4.126h-3.311V56.1A9.968,9.968,0,0,0-16.554,61.607Z",
    transform: "translate(26.537 -41.641)",
    fill: "#34a853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M-22.37,52.24a5.793,5.793,0,0,1-.316-1.905,6.019,6.019,0,0,1,.316-1.905V45.859h-3.311a9.867,9.867,0,0,0-1.073,4.476,9.867,9.867,0,0,0,1.073,4.476Z",
    transform: "translate(26.754 -40.352)",
    fill: "#fbbc05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M-16.554,43.191a5.416,5.416,0,0,1,3.827,1.5l2.845-2.845a9.545,9.545,0,0,0-6.672-2.6,9.968,9.968,0,0,0-8.91,5.507l3.311,2.571A5.962,5.962,0,0,1-16.554,43.191Z",
    transform: "translate(26.537 -39.239)",
    fill: "#ea4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleGLogo);
export default __webpack_public_path__ + "static/media/Google__G__Logo.907c8d74d9fe9dd09a6a44d0e08aaaeb.svg";
export { ForwardRef as ReactComponent };